import '@/assets/fonts/font-feathericons/feather.css';
import '@/assets/fonts/font-icomoon/style.css';
import '@/assets/fonts/font-linearicons/style.css';

// ICONS
import { library } from '@fortawesome/fontawesome-svg-core';

// FREE SOLID
import {} from '@fortawesome/free-solid-svg-icons';

// eslint-disable-next-line import/no-unresolved, import/no-duplicates
import { faRadar, faChevronLeft, faChevronRight, faCircle, faTicket as faTicketSolid, faCalendarExclamation } from '@fortawesome/pro-solid-svg-icons';

// eslint-disable-next-line import/no-unresolved, import/no-duplicates
import { faTimes, faSmileBeam, faGrinWink, faGrinHearts, faLaughBeam, faSync, faAlarmClock, faEllipsisV, faChessKing, faMousePointer, faImage, faClipboard, faCheckCircle, faTimesCircle, faExclamationCircle, faPencil, faTrash as faTrashRegular } from '@fortawesome/pro-regular-svg-icons';

// eslint-disable-next-line import/no-unresolved, import/no-duplicates
import { faGhost, faTransporterEmpty, faHeartbeat, faAlienMonster, faHeart, faTicket, faCactus, faCommentSlash, faCauldron } from '@fortawesome/pro-duotone-svg-icons';

// eslint-disable-next-line import/no-unresolved, import/no-duplicates
import { faTachometerAlt, faUsers, faTicketAlt, faFistRaised, faBoxFull, faCommentsAlt, faSync as falSync, faStars, faEraser, faTrash, faPlusCircle, faList, faEdit, faReply, faInfo, faClock, faEye, faTags, faFileExcel, faServer, faAnalytics, faFileInvoiceDollar, faHandHoldingUsd, faLink, faThumbsUp, faPaste, faDownload, faPercent, faMegaphone } from '@fortawesome/pro-light-svg-icons';

// BRANDS
import { faWordpress, faFacebook, faInstagram, faTwitter, faTelegram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';

const icons = [
	faTachometerAlt, faTimes, faUsers, faTicketAlt, faFistRaised, faBoxFull, faCommentsAlt,
	faSync, faStars, faLaughBeam, faSmileBeam, faGrinWink, faGrinHearts, falSync, faAlarmClock,
	faEraser, faTrash, faGhost, faTransporterEmpty, faHeartbeat, faPlusCircle, faList,
	faAlienMonster, faEdit, faReply, faEllipsisV, faChessKing, faHeart, faTicket, faCactus,
	faCommentSlash, faInfo, faClock, faMousePointer, faImage, faTicket, faEye, faCauldron,
	faWordpress, faRadar, faTags, faClipboard, faFileExcel, faCheckCircle, faTimesCircle,
	faExclamationCircle, faServer, faFacebook, faInstagram, faTwitter, faTelegram, faTiktok,
	faYoutube, faAnalytics, faFileInvoiceDollar, faHandHoldingUsd, faLink, faThumbsUp, faPaste,
	faDownload, faChevronLeft, faChevronRight, faCircle, faPercent, faTicketSolid, faMegaphone,
	faCalendarExclamation, faPencil, faTrashRegular,
].filter(Boolean);

library.add(...icons);
